import { ContentType, getCategoryById, getCategoryBySlugOrId } from '@/admin/utils/categoryService';
import { getCategoryByIdWithCache, getCategoryBySlugOrIdWithCache } from '@/services/categoryService';

// Enum định nghĩa các loại layout catalog có sẵn
export enum CATALOG_LAYOUT_TYPES {
  DEFAULT = 'default',
  BUDDHIST_PRACTICES = 'buddhist-practices',
  FAMILY_EDUCATION = 'family-education',
}

// Định nghĩa trực tiếp các giá trị của COURSE_CATEGORIES để tránh circular dependency
const COURSE_CATEGORY_VALUES = {
  FAMILY: 'family',
  BUDDHISM: 'buddhism',
  WORK: 'work',
  PERSONAL_DEVELOPMENT: 'personal-development',
};

// Interface cho cấu hình layout
export interface CatalogLayoutConfig {
  type: CATALOG_LAYOUT_TYPES;
  options?: Record<string, any>;
}

// Ánh xạ category ID với layout tương ứng (fallback khi không có dữ liệu từ database)
export const CATEGORY_LAYOUT_MAPPING: Record<string, CatalogLayoutConfig> = {
  // Sử dụng layout Buddhist Practices cho category Phật học
  [COURSE_CATEGORY_VALUES.BUDDHISM]: {
    type: CATALOG_LAYOUT_TYPES.BUDDHIST_PRACTICES,
    options: {
      // Các tùy chọn bổ sung cho layout này nếu cần
    }
  },
  
  // Sử dụng layout Family Education cho category Gia đình
  [COURSE_CATEGORY_VALUES.FAMILY]: {
    type: CATALOG_LAYOUT_TYPES.FAMILY_EDUCATION,
    options: {
      // Các tùy chọn bổ sung cho layout này nếu cần
    }
  },
  
  // Các category khác sử dụng layout mặc định
  [COURSE_CATEGORY_VALUES.WORK]: {
    type: CATALOG_LAYOUT_TYPES.DEFAULT,
  },
  
  [COURSE_CATEGORY_VALUES.PERSONAL_DEVELOPMENT]: {
    type: CATALOG_LAYOUT_TYPES.DEFAULT,
  }
};

// Lấy cấu hình layout cho danh mục
export const getCatalogLayoutForCategory = async (categoryId: string): Promise<CatalogLayoutConfig> => {
  if (!categoryId) {
    console.warn('getCatalogLayoutForCategory called with empty categoryId');
    return { type: CATALOG_LAYOUT_TYPES.DEFAULT };
  }
  
  try {
    // Lấy thông tin danh mục từ database (sử dụng service mới với cache nâng cao)
    const category = await getCategoryBySlugOrIdWithCache(categoryId);
    
    // Nếu danh mục có layout_type, sử dụng layout_type đó
    if (category && category.layout_type) {
      return {
        type: category.layout_type as CATALOG_LAYOUT_TYPES,
        options: category.layout_options || {}
      };
    }
    
    // Nếu không có trong database hoặc không có layout_type, 
    // fallback sang dùng mapping cố định
    return CATEGORY_LAYOUT_MAPPING[categoryId] || { type: CATALOG_LAYOUT_TYPES.DEFAULT };
  } catch (error) {
    console.error(`Error getting layout for category ${categoryId}:`, error);
    // Fallback sang layout mặc định trong trường hợp lỗi
    return { type: CATALOG_LAYOUT_TYPES.DEFAULT };
  }
};

// Hàm lấy content type dựa trên loại nội dung
export const getContentTypeForCatalog = (catalogType: string): ContentType => {
  switch (catalogType) {
    case 'courses':
      return ContentType.COURSE;
    case 'diagrams':
      return ContentType.DIAGRAM;
    case 'posts':
      return ContentType.POST;
    default:
      return ContentType.ALL;
  }
};